import { render, staticRenderFns } from "./workOrderDetails.vue?vue&type=template&id=0a2de295&scoped=true"
import script from "./workOrderDetails.vue?vue&type=script&lang=js"
export * from "./workOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./workOrderDetails.vue?vue&type=style&index=0&id=0a2de295&prod&lang=less&scoped=true"
import style1 from "./workOrderDetails.vue?vue&type=style&index=1&id=0a2de295&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2de295",
  null
  
)

export default component.exports